module.exports = __webpack_public_path__ + "static/media/vp_amount.7e4715f3.svg";